module.exports = __webpack_public_path__ + "static/media/7-jul15dec15.22da1a7e.pdf";